<template>
  <div class="radio-buttons" :class="{'is-invalid': showValidationError}">
    <div v-for="option in options" :key="valueForOption(option)" class="d-inline me-3">
      <input :id="inputId(option)" v-model="value"
             type="radio"
             class="form-check-input d-none"
             :name="inputName"
             :value="valueForOption(option)"
             @change="emitNewValue">
      <label class="form-check-label radio-label"
             :class="{'bg-primary-translucent border-primary': optionSelected(option),
                      'radio-not-selected': !optionSelected(option)}"
             :for="inputId(option)">
        {{ displayNameForOption(option) }}
      </label>
    </div>

    <validation-errors v-if="showValidationError" :errors="validationErrors" />
  </div>
</template>

<script>
import radioButtonsInputMixin from './radio-buttons-input-mixin'

export default {
  mixins: [ radioButtonsInputMixin ],

  methods: {
    optionSelected(option) {
      return this.value === this.valueForOption(option)
    },

    reset() {
      this.value = this.initialValue
    }
  }
}
</script>

<style lang="scss" scoped>
  .radio-label{
    border-radius: 8px;
    padding: 0.75rem 1rem;
    border-width: 1px;
    border-style: solid;
    cursor: pointer;
  }

  .radio-not-selected {
    background-color: #f7f7f7;
    border: 1px solid #e2e2e2;
  }
</style>
